import { useEffect, useState } from "react";
import MinusIcon from "../../assets/minusIcon";
import PlusIcon from "../../assets/plus";

interface Props {
  title: string | React.ReactNode;
  expanded?: boolean;
  alwaysOpen?: boolean;
  children: any;
}

const Accordion = (props: Props) => {
  const { title, expanded, alwaysOpen, children } = props;
  const [isExpanded, setIsExpanded] = useState(expanded);

  useEffect(() => {
    setIsExpanded(expanded);
  }, [expanded]);

  if (alwaysOpen) {
    return (
      <div className="accordion accordion--always-open">
        <div className="accordion__title">{title}</div>
        <div className="accordion__content accordion__content--expanded">
          <div className="accordion__content__inner">{children}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="accordion">
      <div
        className="accordion__title"
        onClick={() => setIsExpanded(!isExpanded)}
        role="button"
        aria-expanded={isExpanded}
      >
        {title}
        <span>
          {isExpanded ? (
            <MinusIcon fill="white" width={15} />
          ) : (
            <PlusIcon fill="white" width={15} />
          )}
        </span>
      </div>
      <div
        className={
          isExpanded ? "accordion__content accordion__content--expanded" : "accordion__content"
        }
        aria-hidden={!isExpanded}
      >
        <div className="accordion__content__inner">{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
